<template>
  <div class="fultServiceCenter-action">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" content="故障上报" />
    <ml-tip class="scroll-box" :showHeader="false" style="border: 0">
      <el-scrollbar :height="tabberHeight(185)">
        <!-- 表单 -->
        <ml-form
          ref="faultServiceCenterFormRef"
          labelWidth="200px"
          style="width: 1200px; margin: 20px auto 40px"
          :model="faultServiceCenterForm"
          :rules="faultServiceCenterFormRules"
        >
          <!-- 提示标题 -->
          <el-divider content-position="left" style="font-weight: bold">故障信息</el-divider>
          <el-row>
            <el-col :span="12">
              <ml-select
                prop="companyId"
                placeholder="请选择阿米巴"
                :options="unitOptions"
                label="阿米巴:"
                keyName="companyId"
                labelName="companyName"
                valueName="companyId"
                v-model="faultServiceCenterForm.companyId"
                @change="setCompany"
              />
            </el-col>
            <el-col :span="12">
              <!-- 所属项目 -->
              <ml-select
                prop="projectId"
                placeholder="请选择所属项目"
                :options="projectData"
                label="所属项目:"
                keyName="projectId"
                labelName="projectName"
                valueName="projectId"
                v-model="faultServiceCenterForm.projectId"
                @change="searchProject"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <ml-select
                prop="relatedSite"
                placeholder="请选择关联站点"
                :options="siteListData"
                label="关联站点:"
                keyName="id"
                labelName="siteAddr"
                valueName="id"
                v-model="faultServiceCenterForm.relatedSite"
                :filterable="true"
              />
            </el-col>
            <el-col :span="12">
              <ml-select
                prop="severity"
                placeholder="请选择严重程度"
                :options="severityData"
                label="严重程度:"
                labelName="label"
                valueName="label"
                v-model="faultServiceCenterForm.severity"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <ml-input
                prop="title"
                label="工单标题:"
                placeholder="请输入标题"
                v-model.trim="faultServiceCenterForm.title"
              />
            </el-col>
            <el-col :span="12">
              <ml-input
                prop="address"
                label="故障发生地:"
                placeholder="请输入地点"
                v-model.trim="faultServiceCenterForm.address"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 故障类型级联选择器：只能选择第一级，子级仅展示 -->
              <el-form-item label="故障类型:" prop="errorType">
                <el-cascader
                  v-model="errorType"
                  :options="errorTypeData"
                  :props="{
                    value: 'id',
                    label: 'title',
                    children: 'children',
                    expandTrigger: 'click',
                    checkStrictly: true,
                    emitPath: false
                  }"
                  placeholder="请选择故障类型"
                  clearable
                  style="width: 100%"
                  @change="handleErrorTypeChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 工单流程 -->
              <ml-select
                prop="processData.definitionId"
                placeholder="请选择工单流程"
                :options="processData"
                label="流程:"
                keyName="definitionId"
                labelName="processName"
                valueName="definitionId"
                v-model="faultServiceCenterForm.processData.definitionId"
                @change="definitionChange"
              />
            </el-col>
          </el-row>
          <ml-input
            prop="errorDesc"
            label="故障描述:"
            placeholder="请输入故障描述"
            type="textarea"
            :rows="5"
            v-model.trim="faultServiceCenterForm.errorDesc"
          />
          <el-form-item>
            <ml-list fileName="fileName" :list="faultServiceCenterForm.attachVos" />
          </el-form-item>

          <ml-button :showCancel="false" submitText="上传附件" @click-submit="showUploadDia">
            <!-- <ml-upload
              multiple
              autoUpload
              :showFileList="false"
              :action="action"
              :data="{ linkType: 'error' }"
              :headers="{ Authorization: toKen }"
              name="files"
              @on-success="onSuccess"
            >
              <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary">
                上传附件
              </el-button>
            </ml-upload> -->
          </ml-button>

          <ml-button
            submitText="保存"
            submitIcon="el-icon-document-checked"
            cancelIcon="el-icon-upload2"
            cancelText="上报故障"
            cancelType="success"
            native-type="button"
            :disabledCancel="disabledCancel"
            @click-submit="clickSubmitFultServiceCenter"
            @click-cancel="clickSubmitFultServiceCenter(false)"
          >
            <el-button
              size="medium"
              icon="el-icon-circle-close"
              @click="clickCancelFultServiceCenter"
            >
              返回上一页
            </el-button>
          </ml-button>
        </ml-form>
      </el-scrollbar>
    </ml-tip>
    <!-- 上传附件-资源管理器 -->
    <c-upload-dlg
      v-if="uploadConfig.length > 0"
      ref="cUploadDlgRef"
      v-model="uploadData"
      :config="uploadConfig"
    />
  </div>
</template>

<script>
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getTabberData, tabberHeight, searchParams, getPropertyTypeList } from '@/utils'
// import { BASEURL, FILEUPLOADURL } from '@API'

export default {
  name: 'FultServiceCenterAction',
  setup() {
    const { commit, getters, dispatch } = useStore()
    const router = useRouter()
    const isBusinessDepartment = computed(() => getters.isBusinessDepartment)
    const toKen = computed(() => getters.getToken)
    /* 开始 表单 **********************************/
    // 详情数据
    const faultServiceCenterFormRef = ref()
    const errorType = ref([])
    // 表单配置
    const faultServiceCenterForm = reactive({
      companyId: '',
      projectId: '',
      relatedSite: '',
      errorType: '', // 故障类型
      severity: '',
      title: '',
      address: '',
      errorDesc: '',
      attachVos: [],
      signName: '',
      deviceName: '',
      province: '',
      city: '',
      area: '',
      latitude: '',
      longitude: '',
      processData: {
        businessId: '',
        definitionKey: '',
        definitionId: '',
        procInsId: '',
        businessType: '',
        processName: ''
      }
    })

    // 资产类型
    const propertyTypeList = ref(getPropertyTypeList())
    // 设备类型
    const deviceTypeList = ref([])
    const propertyTypeChange = () => {
      faultServiceCenterForm.deviceType = ''
      faultServiceCenterForm.deviceId = ''
      faultServiceCenterForm.firstUnit = ''
      faultServiceCenterForm.secondUnit = ''
      secondUnitList.value = []
      fetchgetfirstUnitList()
      getEquipmentManageata()
    }
    // 监听资产类型变化
    watch(
      () => faultServiceCenterForm.propertyType,
      newvalue => {
        deviceTypeList.value = []
        if (newvalue) {
          const newPropertyTypeList = propertyTypeList.value.filter(item => item.label === newvalue)
          deviceTypeList.value = newPropertyTypeList[0].value
        }
      }
    )

    const searchfirstUnit = () => {
      faultServiceCenterForm.secondUnit = ''
      getEquipmentManageata()
    }

    const processData = ref([])
    watch(
      () => faultServiceCenterForm.projectId,
      newValue => {
        processData.value = []
        siteListData.value = []
        faultServiceCenterForm.relatedSite = ''
        if (newValue) {
          getProcessData()
          getSiteListData()
        } else {
          faultServiceCenterForm.processData.definitionId = ''
        }
      }
    )
    const getProcessData = () => {
      let params = {
        companyId: '',
        projectId: faultServiceCenterForm.projectId,
        businessType: 'device_error',
        pageIndex: 1,
        pageSize: 500
      }
      dispatch('fetchProjectProcessPage', params).then(res => {
        if (res.code === 200) {
          processData.value = res.data.records
          const item = processData.value.find(
            d => d.definitionId === faultServiceCenterForm.processData.definitionId
          )
          if (!item) {
            let processDataValue = processData.value[0] || {}
            faultServiceCenterForm.processData.definitionId = processDataValue.definitionId || ''
            faultServiceCenterForm.processData.definitionKey = processDataValue.processKey || ''
            faultServiceCenterForm.processData.businessType = processDataValue.businessType || ''
            faultServiceCenterForm.processData.processName = processDataValue.processName || ''
          }
        }
      })
    }

    const definitionChange = value => {
      if (value) {
        const item = processData.value.find(d => d.definitionId === value)
        faultServiceCenterForm.processData.definitionKey = (item && item.processKey) || ''
        faultServiceCenterForm.processData.businessType = (item && item.businessType) || ''
        faultServiceCenterForm.processData.processName = (item && item.processName) || ''
      } else {
        faultServiceCenterForm.processData.definitionKey = ''
        faultServiceCenterForm.processData.businessType = ''
        faultServiceCenterForm.processData.processName = ''
      }
    }

    watch(
      () => faultServiceCenterForm.firstUnit,
      () => {
        fetchgetsecondUnitList()
      }
    )

    const deviceTypeChange = () => {
      faultServiceCenterForm.deviceId = ''
      faultServiceCenterForm.firstUnit = ''
      faultServiceCenterForm.secondUnit = ''
      fetchgetfirstUnitList()
      getEquipmentManageata()
    }
    // 一级单位
    const fetchgetfirstUnitList = () => {
      const { companyId, projectId, propertyType, deviceType } = faultServiceCenterForm
      const firstUnitParams = {
        projectId,
        companyId
      }
      if (propertyType) {
        firstUnitParams.propertyType = propertyType
      }
      if (deviceType) {
        firstUnitParams.deviceType = deviceType
      }
      dispatch('fetchgetfirstUnitList', firstUnitParams).then(data => {
        if (data && data.code === 200) {
          if (data.data && data.data.length > 0) {
            firstUnitList.value = data.data.map(item => {
              return {
                label: item
              }
            })
          } else {
            firstUnitList.value = []
          }
        }
      })
    }
    // 二级单位
    const fetchgetsecondUnitList = () => {
      const { companyId, projectId, propertyType, deviceType, firstUnit } = faultServiceCenterForm
      const secondUnitParams = {
        projectId,
        companyId,
        propertyType,
        deviceType,
        firstUnit
      }

      dispatch('fetchgetsecondUnitList', secondUnitParams).then(data => {
        if (data && data.code === 200) {
          if (data.data && data.data.length > 0) {
            secondUnitList.value = data.data.map(item => {
              return {
                label: item
              }
            })
          } else {
            secondUnitList.value = []
          }
        }
      })
    }

    // 类型下拉列表
    const typeData = ref([{ label: '故障' }, { label: '缺陷' }])
    // 严重程度下拉列表
    const severityData = ref([
      { label: '轻微' },
      { label: '一般' },
      { label: '严重' },
      { label: '灾难' }
    ])
    // 站点列表数据
    const siteListData = ref([])
    // 故障类型字典数据
    const errorTypeData = ref([])
    // 单位名下拉列表
    const unitOptions = ref([])
    // 设备选中信息
    const deviceNode = ref({})
    // 所属项目下拉列表
    const projectData = ref([])
    // 一级单位
    const firstUnitList = ref([])
    // 二级单位
    const secondUnitList = ref([])
    // 设备下拉列表
    const equipmentManageata = ref([])
    // 处理所属项目
    const getProjectData = async companyId => {
      const projectParams = { projectStatus: 'Y' }
      if (isBusinessDepartment.value) {
        projectParams.companyId = companyId
      }
      const { data } = await getTabberData(dispatch, 'fetchGetProjectsByCompany', projectParams)
      projectData.value = data || []
    }

    // 获取站点列表
    const getSiteListData = async () => {
      try {
        // 根据接口文档，站点列表查询只需要 siteAddr 参数
        const siteParams = {
          siteAddr: '', // 空字符串表示查询所有站点
          projectId: faultServiceCenterForm.projectId || ''
        }
        const data = await dispatch('fetchGetPcsSiteList', siteParams)
        if (data && data.code === 200) {
          siteListData.value = data.data || []
        }
      } catch (error) {
        console.error('获取站点列表失败:', error)
      }
    }

    // 处理故障类型数据：子级禁用 + 清理空children
    const processErrorTypeData = data => {
      if (!data || !Array.isArray(data)) return []
      return data.map(item => {
        const newItem = { ...item }
        // 如果有子级，处理子级
        if (newItem.children && newItem.children.length > 0) {
          // 子级全部禁用（不可选择，仅展示）
          newItem.leaf = false
          newItem.children = newItem.children.map(child => ({
            ...child,
            disabled: true,
            leaf: child.children && child.children.length > 0 ? false : true
          }))
        } else {
          newItem.leaf = true
          // 没有子级，删除 children 属性，避免展开空面板
          delete newItem.children
        }
        return newItem
      })
    }

    // 获取故障类型字典数据
    const getErrorTypeData = async () => {
      try {
        const data = await dispatch('fetchGetDictTreeByType', { dictType: 'error_type' })
        if (data && data.code === 200) {
          errorTypeData.value = processErrorTypeData(data.data) || []
        }
      } catch (error) {
        console.error('获取故障类型字典失败:', error)
      }
    }

    // 处理故障类型选择变化
    const handleErrorTypeChange = value => {
      console.log('handleErrorTypeChange', value)
      // 只保留第一级选择的值
      faultServiceCenterForm.errorType = value
    }

    const setCompany = () => {
      faultServiceCenterForm.projectId = ''
      faultServiceCenterForm.deviceId = ''
    }
    // 处理设备
    const getEquipmentManageata = async () => {
      const { companyId, projectId, propertyType, deviceType, firstUnit, secondUnit } =
        faultServiceCenterForm
      const projectParams = {
        projectId,
        companyId
      }
      if (propertyType) {
        projectParams.propertyType = propertyType
      }
      if (deviceType) {
        projectParams.deviceType = deviceType
      }
      if (firstUnit) {
        projectParams.firstUnit = firstUnit
      }
      if (secondUnit) {
        projectParams.secondUnit = secondUnit
      }

      const { data } = await getTabberData(dispatch, 'fetchGetDeviceInfos', projectParams)
      equipmentManageata.value = data || []
    }
    // 监听项目
    const searchProject = () => {
      // faultServiceCenterForm.relatedSite = ''
    }

    // 监听单位
    watch(
      () => faultServiceCenterForm.companyId,
      newvalue => {
        getProjectData(newvalue)
      }
    )
    // 监听设备
    watch(
      () => deviceNode.value,
      newvalue => {
        const {
          deviceName,
          province,
          city,
          area,
          latitude,
          longitude,
          address,
          propertyType,
          deviceType,
          firstUnit,
          secondUnit
        } = newvalue
        faultServiceCenterForm.deviceName = deviceName
        faultServiceCenterForm.propertyType = propertyType
        faultServiceCenterForm.deviceType = deviceType
        faultServiceCenterForm.firstUnit = firstUnit
        faultServiceCenterForm.secondUnit = secondUnit
        faultServiceCenterForm.province = province
        faultServiceCenterForm.city = city
        faultServiceCenterForm.area = area
        faultServiceCenterForm.latitude = latitude
        faultServiceCenterForm.longitude = longitude
        faultServiceCenterForm.address = address
      }
    )

    // 表单校验
    const faultServiceCenterFormRules = {
      companyId: [{ required: true, message: '请选择阿米巴 ', trigger: 'blur' }],
      projectId: [{ required: true, message: '请选择所属项目', trigger: 'blur' }],
      title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
      severity: [{ required: true, message: '请选择严重程度', trigger: 'blur' }],
      address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
      errorDesc: [{ required: true, message: '请输入故障描述', trigger: 'blur' }],
      errorType: [{ required: true, message: '请选择故障类型', trigger: 'blur' }],
      relatedSite: [{ required: true, message: '请选择关联站点', trigger: 'blur' }],
      processData: {
        definitionId: [{ required: true, message: '请选择流程', trigger: 'blur' }]
      }
    }
    // 提交表单
    const disabledCancel = ref(false)
    const clickSubmitFultServiceCenter = (save = true) => {
      const actionName = save ? 'fetchAddDeviceErrorDraft' : 'fetchNewAddDeviceErrorRecord'
      faultServiceCenterFormRef.value.CustomFormRef.validate()
        .then(() => {
          disabledCancel.value = true
          const faultServiceCenterParams = searchParams(faultServiceCenterForm, [])
          //
          dispatch(actionName, faultServiceCenterParams).then(data => {
            if (data && data.code === 200) {
              commit('setError', {
                status: true,
                title: data.message,
                message: '正在获取新的数据...',
                type: 'success'
              })
              disabledCancel.value = false
              if (!save) {
                router.go(-1)
              }
            }
          })
        })
        .catch(() => {})
    }
    // 取消表单
    const clickCancelFultServiceCenter = () => {
      router.go(-1)
    }

    const getFaultServiceCenterDetails = () => {
      dispatch('fetchGetDeviceErrorDraft').then(data => {
        if (data && data.code === 200) {
          Object.keys(faultServiceCenterForm).map(item => {
            if (data.data) {
              if (['attachVos'].includes(item)) {
                faultServiceCenterForm[item] = data.data[item] || []
              } else {
                faultServiceCenterForm[item] = data.data[item]
              }
            }
          })
          errorType.value = faultServiceCenterForm.errorType
            ? [faultServiceCenterForm.errorType]
            : []
        }
      })
    }

    // 上传附件
    // const action = ref(`${BASEURL}${FILEUPLOADURL}`)
    // const onSuccess = files => {
    //   if (files.data) {
    //     faultServiceCenterForm.attachVos = [...faultServiceCenterForm.attachVos, ...files.data]
    //   }
    // }

    /* 结束 用户表单 **********************************/

    /* 2021-12-15 新版上传文件管理器 wml ******************/
    // 上传资源管理器属性
    const cUploadDlgRef = ref()
    const uploadData = ref([])
    const uploadConfig = ref([])

    watch(
      () => uploadData.value,
      newvalue => {
        faultServiceCenterForm.attachVos = [...faultServiceCenterForm.attachVos, ...newvalue]
      }
    )
    // 打开对话框
    const showUploadDia = () => {
      const { companyId, projectId } = faultServiceCenterForm
      uploadData.value = []
      const nArr = []
      if (companyId) {
        nArr.push(companyId)
        if (projectId) {
          nArr.push(projectId)
        }
      }
      uploadConfig.value = [...nArr]
      nextTick(() => {
        cUploadDlgRef.value.uploadDialogRef.showDialog = true
      })
    }
    /* 2021-12-15 新版上传文件管理器 wml ******************/

    onMounted(async () => {
      // 获取单位名
      const { data } = await getTabberData(dispatch, 'fetchGetCompanyInfos', {
        noCompanyCode: 'business_department'
      })
      unitOptions.value = data || []
      if (data.length > 0) {
        faultServiceCenterForm.companyId = data[0].companyId
      }
      await getFaultServiceCenterDetails()
      // getSiteListData()
      getErrorTypeData()
    })
    return {
      faultServiceCenterForm,
      unitOptions,
      projectData,
      faultServiceCenterFormRules,
      clickSubmitFultServiceCenter,
      clickCancelFultServiceCenter,
      tabberHeight,
      faultServiceCenterFormRef,
      setCompany,
      equipmentManageata,
      typeData,
      severityData,
      // onSuccess,
      // action,
      toKen,
      deviceNode,
      uploadData,
      showUploadDia,
      cUploadDlgRef,
      uploadConfig,
      disabledCancel,
      propertyTypeList,
      deviceTypeList,
      propertyTypeChange,
      deviceTypeChange,
      firstUnitList,
      secondUnitList,
      searchProject,
      getEquipmentManageata,
      searchfirstUnit,
      processData,
      getProcessData,
      definitionChange,
      getFaultServiceCenterDetails,
      siteListData,
      getSiteListData,
      errorTypeData,
      getErrorTypeData,
      handleErrorTypeChange,
      errorType
    }
  }
}
</script>

<style lang="scss">
.fultServiceCenter-action {
  position: relative;
}
</style>
